export default "__VITE_ASSET__qf4Fmo4b__"